module.exports = __webpack_public_path__ + "static/media/eu.ed03cd43.svg";